// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Branch_wrapper__xyFRL","icon":"Branch_icon__SLM5y","svg":"Branch_svg__ttMlN"};